// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"184":"0ac1d85c","690":"9460655d"}[chunkId] + ".css";
};